// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import { useEffect } from 'react'

export const useTooltips = (isModalOpen) => {
    useEffect(() => {
        if (!isModalOpen) return

        const elements = document.querySelectorAll('[data-tip]')
        const tooltips = []

        elements.forEach((el) => {
            const text = el.getAttribute('data-tip')
            if (!text) return

            const tooltip = document.createElement('div')
            tooltip.className = 'tooltip'
            tooltip.textContent = text

            const x = el.hasAttribute('tip-left') ? 'calc(-100% - 5px)' : '16px'
            const y = el.hasAttribute('tip-top') ? '-100%' : '0'
            tooltip.style.transform = `translate(${x}, ${y})`

            el.appendChild(tooltip)
            tooltips.push({ el, tooltip })

            const moveHandler = (e) => {
                if (e.target !== e.currentTarget) return

                const rect = tooltip.getBoundingClientRect()
                const rectWidth = rect.width + 16
                const vWidth = window.innerWidth - rectWidth
                const rectX = el.hasAttribute('tip-left') ? e.clientX - rectWidth : e.clientX + rectWidth
                const minX = el.hasAttribute('tip-left') ? 0 : rectX
                const maxX = el.hasAttribute('tip-left') ? vWidth : window.innerWidth
                const x = rectX < minX ? rectWidth : rectX > maxX ? vWidth : e.clientX

                tooltip.style.left = `${x}px`
                tooltip.style.top = `${e.clientY}px`
            }

            el.addEventListener('pointermove', moveHandler)
            el._tooltipMoveHandler = moveHandler // Save reference for cleanup
        })

        return () => {
            // Cleanup tooltips and events
            tooltips.forEach(({ el, tooltip }) => {
                el.removeEventListener('pointermove', el._tooltipMoveHandler)
                delete el._tooltipMoveHandler
                el.removeChild(tooltip)
            })
        }
    }, [isModalOpen])
}
